import { Action } from '@ngrx/store';
import { ILegalEntity } from '@cemex-core/cmx-api/models/legal-entities/legal-entity';

// TODO: Refactor to standard actions format with Action Types enum and so on... (i.e. see project profile actions).

export const LOAD = '[Customer] Load';
export const LOAD_COMPLETE = '[Customer] Load Complete';
export const LOAD_FAIL = '[Customer] Load Fail';
export const LOAD_FEATURES = '[Customer] Load Features';
export const LOAD_FEATURES_SUCCESS = '[Customer] Loading of Features Success';
export const LOAD_FEATURES_FAIL = '[Customer] Loading of Features Failed';

export class CustomerLoadAction implements Action {
  readonly type = LOAD;
}

export class CustomerLoadCompleteAction implements Action {
  readonly type = LOAD_COMPLETE;

  constructor(public payload: ILegalEntity) {}
}

export class CustomerLoadFail implements Action {
  readonly type = LOAD_FAIL;

  constructor(public payload: any) {}
}

export class CustomerLoadFeaturesAction implements Action {
  readonly type = LOAD_FEATURES;

  constructor(public payload: string) {}
}

export class CustomerLoadFeaturesSuccessAction implements Action {
  readonly type = LOAD_FEATURES_SUCCESS;

  constructor(public payload: any) {}
}

export class CustomerLoadFeaturesFailAction implements Action {
  readonly type = LOAD_FEATURES_FAIL;
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type CustomerActions =
  | CustomerLoadAction
  | CustomerLoadCompleteAction
  | CustomerLoadFail
  | CustomerLoadFeaturesAction
  | CustomerLoadFeaturesSuccessAction
  | CustomerLoadFeaturesFailAction;
